import React from "react";
import { Route } from "react-router-dom";
import auth from './AuthService';
import { inIframe } from "./components/Layout";
import { EVO } from "./EVO";
import { Unauthorised } from "./Unauthorised";


const AuthenticateRoute = ({ component: Component, roles, allowNotInIframe, render, ...rest }) => (
    <Route {...rest}
        render={props => {
            if (!auth.getInstance().isAuthenticated()) {
                if (props && props.location && props.location.pathname) {
                    EVO.storage.set('_evo_loginReturnPath', props.location.pathname);
                }

                return auth.getInstance().login();
            }

            if (roles) {
                const user = auth.getInstance().getUser();
                const userRoles = (user || {}).roles || [];
                let roleIntersection = roles.filter(r => userRoles.includes(r));
                if (roleIntersection.length === 0) {
                    return <Unauthorised />;
                }
            }

            if (!allowNotInIframe) {
                if (!inIframe() && !auth.getInstance().isAdmin() && process.env.NODE_ENV !== 'development' && !EVO.storage.get('evo_allowiframe')) {
                    return <Unauthorised />;
                }
            }

            return render();
        }}
    />
);

export default AuthenticateRoute;


// WEBPACK FOOTER //
// ./src/AuthenticateRoute.js